/** What `encodeBookModelForPersist` does with the model: pass it through untouched or encode to v1. */
export type PersistEncodeMode = 'identity' | 'custom-template-v1';

/** Raw config values as each runtime holds them (env vars on the backend, `environment` on the FE). */
export interface PersistEncodeGateEnv {
  /** 'on' opens the gate globally; anything else keeps it closed. */
  readonly globalValue?: string | null;
  /** Comma-separated project ids the gate is open for even while `globalValue` is off. */
  readonly projectIdAllowlistCsv?: string | null;
}

export function resolvePersistEncodeMode(env: PersistEncodeGateEnv, projectId?: string | null): PersistEncodeMode {
  const allowlist = (env.projectIdAllowlistCsv ?? '')
    .split(',')
    .map(id => id.trim())
    .filter(Boolean);
  if (projectId && allowlist.includes(projectId)) return 'custom-template-v1';
  return env.globalValue === 'on' ? 'custom-template-v1' : 'identity';
}
